<template>
  <div class="one-survey-read">
    <readLayout>
      <h2>
        {{ $store.getters.oneSurvey.title }}
      </h2>
      <p class="date-in-title">{{ $store.getters.oneSurvey.released_at }}</p>
      <div v-html="$store.getters.oneSurvey.content"></div>
    </readLayout>
  </div>
</template>

<script>
import readLayout from "@/layout/ReadLayout.vue";
export default {
  components: {
    readLayout
  }
};
</script>

<style lang="scss" scoped></style>
